import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await requestPasswordReset(email);
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Une erreur est survenue. Réessayez plus tard.');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 460, padding: 24 }}>
        <div className="card" style={{ padding: 40 }}>
          <h1 style={{ fontSize: 22, marginBottom: 8, textAlign: 'center' }}>Mot de passe oublié</h1>
          <p style={{ textAlign: 'center', color: 'var(--text-light)', marginBottom: 28, fontSize: 13.5, lineHeight: 1.55 }}>
            Saisissez l'adresse email associée à votre compte. Nous vous
            enverrons un lien sécurisé pour choisir un nouveau mot de passe.
          </p>

          {submitted ? (
            <>
              <div style={{
                background: '#E8F5E9', color: '#1B5E20',
                padding: 16, borderRadius: 8, fontSize: 13.5, lineHeight: 1.55,
                marginBottom: 20,
              }}>
                <strong>Demande enregistrée.</strong>
                <br />
                Si un compte existe pour cette adresse, vous recevrez un email
                contenant un lien de réinitialisation valable 1 heure. Pensez à
                vérifier vos courriers indésirables.
              </div>
              <Link to="/login" className="btn btn-primary" style={{
                width: '100%', justifyContent: 'center', padding: '12px 0', fontSize: 14,
              }}>
                Retour à la connexion
              </Link>
            </>
          ) : (
            <>
              {error && (
                <div style={{
                  background: '#FFEBEE', color: '#C62828',
                  padding: 12, borderRadius: 8, marginBottom: 16, fontSize: 14,
                }}>
                  {error}
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6, color: 'var(--text-light)' }}>
                    Email
                  </label>
                  <input
                    type="email" value={email} onChange={e => setEmail(e.target.value)} required
                    autoFocus autoComplete="email"
                    style={{ width: '100%', padding: '12px 16px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 14, fontFamily: 'inherit' }}
                    placeholder="votre@email.fr"
                  />
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading || !email}
                  style={{ width: '100%', justifyContent: 'center', padding: '14px 0', fontSize: 15 }}>
                  {loading ? 'Envoi...' : 'Envoyer le lien de réinitialisation'}
                </button>
              </form>
              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <Link to="/login" style={{ fontSize: 14 }}>Retour à la connexion</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
